import { FormField, Switch, SwitchColorEnum } from '@acceso/design-system';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type TInputSwitchProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  disabled?: boolean;
  label?: string;
};

export function SwitchEnrichment<T extends FieldValues>({
  form,
  name,
  disabled,
}: TInputSwitchProps<T>) {
  const { t } = useTranslation();
  const { control } = form;

  return (
    <FormField className="flex items-end">
      <Controller
        disabled={disabled}
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <Switch
            startLabel={t('Configurado por la emisora')}
            checked={value}
            onChange={checked => {
              onChange(checked);
            }}
            color={SwitchColorEnum.SUCCESS}
          />
        )}
      />
    </FormField>
  );
}
